import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Button, Colors } from '@utex/ui-kit';
import { BaseModal } from '../Base';
import { useModalService } from '../../../hooks/useModalService';

export const BankSuccessModal: React.FC = () => {
  const { t } = useTranslation('toBank');
  const { close } = useModalService();

  return (
    <BaseModal
      icon="success"
      testId="withdraw-success-modal"
      title={t('Success Title')}
      footer={
        <Button isLong={true} view="regular-shadow" onClick={close}>
          {t('Success Button Text')}
        </Button>
      }
      backgroungColor={Colors.ut.successDim}
    >
      <Typography.Text>{t('Success Text')}</Typography.Text>
    </BaseModal>
  );
};
